/**
 * The TreeGenerator class provides random parameter 
 * for tree diagrams, which can be accessed by any user. 
 * This class is mainly used for automatic exercise generation.
 */
export class TreeGenerator {
    private static numberAlphabet: string[] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    private static charAlphabet: string[] = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k"
        , "l", "m", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
    private static specCharAlphabet: string[] = [".", ":", "-", "+", "$", "£", "{", "}", "*", "ç", "&", "/", "(", ")"];
    private static colorAlphabet: string[] = ["Yellow", "Red", "Green", "Silver", "Blue", "Fuchsia", "Purple", "Black", "White"];

    static generateMultiWordTree(): [[any[], number][], string, boolean] {
        let definition: string = "";
        let alphabets: [any[], number][] = [];
        let hasRepetion: boolean = false;

        hasRepetion = Math.floor(Math.random() * 10) % 2 == 0;

        definition = "Gegeben sei ein Wortbaum, welcher die folgenden Eigenschaften besitzt: \n";
        let position: number = 1;

        let amountAlphabet: number = Math.floor(Math.random() * 3) + 1;
        for (let i = 0; i < amountAlphabet; i++) {
            let lengthAlp: number = Math.floor(Math.random() * 2) + 1;
            let sizeAlp: number = Math.floor(Math.random() * 3)+1;
            if(amountAlphabet > 2){
                sizeAlp = Math.min(2, sizeAlp);
            }
            let domain: string[] = [];
            let alphabet: any[] = [];

            let domainIndex: number = Math.floor(Math.random() * 5) + 1;
            switch (domainIndex) {
                case 1: case 3: case 5: domain = this.numberAlphabet; break;
                case 2: case 4: domain = this.charAlphabet; break;
                default: domain = this.specCharAlphabet; break;
            }
            while (alphabet.length < sizeAlp) {
                let alpIndex: number = Math.floor(Math.random() * domain.length);
                let elem: string = domain[alpIndex];

                if (!alphabet.includes(elem)) {
                    alphabet.push(elem);
                }
            }
            alphabets.push([alphabet, lengthAlp]);
            if (lengthAlp > 1) {
                let x = position + lengthAlp - 1;
                definition = definition + "An " + position + "-" + x + "ter Stelle stehen Symbole aus dem Alphabet: " + alphabet + ". \n"
            }
            else {
                definition = definition + "An " + position + "ter Stelle steht ein Symbol aus dem Alphabet: " + alphabet + ". \n"
            }

            position = position + lengthAlp;
        }

        if (hasRepetion)
            definition = definition + "Symbole eines Alphabets können sich wiederholen\n";
        else
            definition = definition + "Symbole eines Alphabets können sich NICHT wiederholen\n";

        definition = definition + "Vervollständige den Wortbaum, indem du die leeren Knoten den entsprechenden Wörter zuweist. Klicke beide an um die Zuweisung zu tätigen";


        return [alphabets, definition, hasRepetion];
    }

    static generateColoredFlagTree(): [string[], number, string, boolean] {
        let domain: string[] = this.colorAlphabet;
        let alphabet: string[] = [];
        let hasRepetion: boolean = false;
        let lengthAlp: number = Math.floor(Math.random() * 4) + 1;
        let depth: number = lengthAlp;
        let definition: string = "";

        hasRepetion = Math.floor(Math.random() * 10) % 2 == 0;

        while (lengthAlp > 0) {
            let index: number = Math.floor(Math.random() * domain.length);
            let elem: any = domain[index];

            if (!alphabet.includes(elem)) {
                alphabet.push(elem);
                lengthAlp = lengthAlp - 1;
            }
        }

        if(hasRepetion){
            depth = Math.floor(Math.random()*lengthAlp+2)+1;
        }else{
            depth = Math.min(alphabet.length,Math.floor(Math.random()*lengthAlp+1)+1);
        }

        definition = "Gegeben sei ein Flaggenbaum mit den folgenden Farben: \n";
        definition = definition + alphabet + ".\n";
        definition = definition + "Jede Flagge ist in " + depth + " Farbsektoren unterteilt.\n"

        if (hasRepetion) {
            definition = definition + "Die Farben können sich wiederholen\n";
        }
        else {
            definition = definition + "Die Farben können sich NICHT wiederholen\n";
        }

        return [alphabet, depth, definition, hasRepetion];
    }



}
